import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({
  name: 'InputErrorText',
})(({ brandColors, type, typography: { pxToRem } }) => ({
  error: {
    color: brandColors.errorMain,
    ...type['14_medium'],
    display: 'flex',
    alignItems: 'center',
    gap: pxToRem(4),
    lineHeight: pxToRem(20),
    '& svg': {
      marginTop: pxToRem(2),
    },
  },
}));

export default useStyles;
